<template lang="pug">
  #app
    transition(name="fade")
      Loading(v-if="isLoading")
    #container(:class="{'is-popup': popup}" ref="container")
      Header
      Main
    transition(name="fade")
      #popup(v-if="popup")
        .popup__container
          PopupRecruitment(v-if="popup.type === 'recruitment'" :position="popup.position")
    CookiePolicy
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { mixins } from '@/utils/mixins';

import Header           from './components/Header.vue';
import Main             from './components/Main.vue';
import PopupRecruitment from './components/PopupRecruitment';
import CookiePolicy     from './components/CookiePolicy.vue';
import Loading          from './components/Loading.vue';

export default {
  name: 'App',
  mixins: [mixins],
  computed: {
    ...mapState(['popup', 'isLoading']),
  },
  data: () => {
    return {
      isMobile: null,
      // myBgmInited: false,
    }
  },
  watch: {
    popup() {
      const { container } = this.$refs;
      let scrollTop = 0;
      let containerTop = Math.abs(parseInt(container.style.top)) || 0;
      if (this.popup) { scrollTop = document.documentElement.scrollTop || document.body.scrollTop || 0; }
      container.style.top = -scrollTop + 'px';
      setTimeout(() => { window.scrollTo(0, containerTop) }, 0);
    },
  },
  methods: {
    ...mapMutations(['setTargetString']),
    setCssVariable() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    setDefaultHeight() {
      if (this.isMobile) return;
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--default-vh', `${vh}px`);
    },
    getParameterByName(search) {
      let name = search.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
      let regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(location.search);
      return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    },
    checkIsMobile() {
      this.isMobile = window.matchMedia('(max-width: 750px)').matches;
    },
    onResize() {
      const { setCssVariable, setDefaultHeight, checkIsMobile } = this;
      setCssVariable();
      setDefaultHeight();
      checkIsMobile();
    },
    // toggleBgm() {
    //   const { mybgm } = this.$refs;
    //   var playPromise = mybgm.play();
    //   // In browsers that don't yet support this functionality,
    //   // playPromise won't be defined.
    //   if (playPromise !== undefined) {
    //     playPromise.then(function() {
    //       // Automatic playback started!
    //       // $('.btn-playmusic').toggleClass('is-muted');
    //       mybgm.muted = !mybgm.muted; 
    //     }).catch(function(error) {
    //       console.error(error);
    //       // Automatic playback failed.
    //       // Show a UI element to let the user manually start playback.
    //     });
    //   }
    // }
    // loaded: function() {
    //   setTimeout(() => {
    //     this.setLoading(false);
    //   }, 1000)
    // }
  },
  created() {
    const { onResize } = this;
    window.addEventListener('resize', onResize);
  },
  mounted() {
    const {
      setCssVariable,
      setDefaultHeight,
      checkIsMobile,
      getParameterByName,
      setTargetString
    } = this;
    setCssVariable();
    setDefaultHeight();
    checkIsMobile();
    const target = getParameterByName('target') || 'change';
    setTargetString(target);
  },
  components: {
    Header,
    Main,
    PopupRecruitment,
    CookiePolicy,
    Loading,
  }
}

</script>

<style lang="scss">

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  // width: 750px;
  min-height: calc(var(--vh, 1vh) * 100);
  margin: 0 auto;
  // background-size: vwXL(32) vwXL(33);
  @include tablet {
    width: vw(750);
    min-height: calc(var(--vh, 1vh) * 100);
    // background-size: vw(32) vw(33);
  }
}

#container {
  position: relative;
  width: 100%;
  // width: 750px;
  margin: 0 auto;
  @include tablet {
    width: 100%;
  }
  &.is-popup {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    @include tablet {
      left: 0;
      transform: translateX(0);
    }
  }
}

#popup {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  min-height: 100%;
  z-index: 2;
  &.fade-leave-active {
    position: fixed;
  }
}

.popup__container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  height: auto;
  min-height: 100%;
  overflow: hidden;
  // background: rgba(#c2e3d1, 0.6);
  @include tablet {
  }
}

.popup__main {
  position: relative;
  margin: 50px 0;
  @include tablet {
    margin: vw(50) 0;
  }
}

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .5s;
  transition-timing-function: ease;
}

.fade-enter-active {
  transition-delay: 0s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}

</style>
